import React from "react";

import { graphql } from "gatsby";

import MegaMenuResult from "../../../components/megaMenuResult/megaMenuResult";
import KontentItemImage from "../../kontentItemImage";

interface MegaMenuResultDonorAreaProps {
  data: Queries.kontent_item_article_donor_area;
}

const MegaMenuResultDonorArea: React.FC<MegaMenuResultDonorAreaProps> = ({ data }) => (
  <MegaMenuResult
    href={data.id}
    image={(
      <KontentItemImage
        data={data.elements?.hero_image?.value?.[0] as Queries.kontent_item_image}
        width={48}
        height={48}
        aspectRatio={1}
        fit="crop"
        defaultImage
      />
    )}
  >
    {data.elements?.headline?.value}
  </MegaMenuResult>
);

export const query = graphql`
  fragment MegaMenuResultDonorArea on kontent_item_article_donor_area {
    id
    elements {
      headline {
        value
      }
      hero_image {
        value {
          ...KontentItemImage
        }
      }
    }
  }
`;

export default MegaMenuResultDonorArea;
